
const apiProxy = require('./apiProxy.js');
const stateManager = require('../../utils/state/stateManager.js');


export async function enrichBasket()
{
    var basket = stateManager.getStore().getState().basket;
   
    return apiProxy.put("enrich", basket)
    .then(serverBasket=>
    {
        basket.order = serverBasket.order;

        basket.dispatchInfo = serverBasket.dispatchInfo;
        basket.voucherCode = serverBasket.voucherCode;
        
        return Promise.resolve(serverBasket.messages);
    }, error =>
    {
        return Promise.reject(error);
    });
}

export async function postBasket()
{
    var basket = stateManager.getStore().getState().basket;
   
    try 
    {
        return await apiProxy.post("basket", basket);
    } 
    catch (error) 
    {
        return Promise.reject(error);
    }    
}